import {EvkSeccionModel} from "./evk-seccion.model";
import {EvkExpedienteConfigModel} from "./evk-expediente-config.model";
import {EstadoModel} from "./estado.model";

export class EvkExpedienteModel {

    id: string;
    folioProvisional: string;
    folio: string;
    configuracionExpediente: EvkExpedienteConfigModel;
    secciones: EvkSeccionModel[];
    created: any;
    createdBy: string;
    updated: any;
    updatedBy: string;
    activo: boolean;
    generarFolio: boolean;
    origen: any;
    estados: EstadoModel[];
    estadoActivo: EstadoModel;
    indiciosAsociados: any;
    esDiligencia: boolean
    idDiligencia: string;
    idExpediente: string;
    idDiligenciaConfig: string;
    folioDiligencia: string;
    idDiligenciaPadre: string;
    enviadaComoRespuesta: boolean;
    firma: any;
}
